import { useDiagramTheme } from './useDiagramTheme';

export function TrackGeometryDiagram() {
  const p = useDiagramTheme();

  const categories = ['Initiatives', 'Features', 'Bugs / Debt'];
  const altitudes = ['Strategic', 'Portfolio', 'Team'];

  return (
    <div className="w-full space-y-4">
      {/* Comparison Cell matrix */}
      <div
        className="border p-5 transition-colors"
        style={{ background: p.canvasBg, borderColor: p.canvasBorder }}
      >
        <p className="text-xs font-semibold uppercase tracking-wide mb-3" style={{ color: p.nodeSubText }}>
          Comparison Cell = Item Category × Altitude
        </p>
        <div className="overflow-x-auto">
          <table className="border-collapse" style={{ minWidth: 360 }}>
            <thead>
              <tr>
                <th className="w-28" />
                {altitudes.map((a) => (
                  <th
                    key={a}
                    className="px-4 py-2 text-xs font-semibold text-center"
                    style={{
                      background: p.indigoBg,
                      borderColor: p.indigoBorder,
                      color: p.indigoText,
                      border: `1px solid ${p.indigoBorder}`,
                    }}
                  >
                    {a}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {categories.map((cat, ci) => (
                <tr key={cat}>
                  <td
                    className="px-3 py-2 text-xs font-semibold"
                    style={{
                      background: p.greenBg,
                      borderColor: p.greenBorder,
                      color: p.greenText,
                      border: `1px solid ${p.greenBorder}`,
                    }}
                  >
                    {cat}
                  </td>
                  {altitudes.map((alt, ai) => {
                    const isA = ci === 0 && ai === 0;
                    const isB = ci === 1 && ai === 2;
                    return (
                      <td
                        key={alt}
                        className="px-3 py-3 text-center text-xs"
                        style={{
                          border: `1px solid ${p.canvasBorder}`,
                          background: isA ? p.violetBg : isB ? p.amberBg : p.nodeBg,
                          color: isA ? p.violetText : isB ? p.amberText : p.nodeSubText,
                          fontWeight: isA || isB ? 600 : 400,
                        }}
                      >
                        {isA ? 'Comparison Cell A' : isB ? 'Comparison Cell B' : '—'}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs mt-2" style={{ color: p.nodeSubText }}>
          Each cell defines a unique comparability boundary. Items in "Initiatives × Strategic" can only be compared to each other.
        </p>
      </div>

      {/* Comparison Cell vs Track cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div
          className="border p-4 transition-colors"
          style={{ background: p.violetBg, borderColor: p.violetBorder }}
        >
          <p className="text-xs font-bold uppercase tracking-wide mb-1" style={{ color: p.violetText }}>Comparison Cell</p>
          <p className="text-sm font-semibold mb-1" style={{ color: p.nodeText }}>Pure geometry</p>
          <ul className="space-y-0.5">
            {['Item Category + Altitude', 'Defines comparability', 'No cycle, scope, or time', 'Reusable across cycles'].map((t) => (
              <li key={t} className="text-xs flex items-center gap-1.5" style={{ color: p.violetText }}>
                <span className="w-1 h-1 rounded-full flex-shrink-0" style={{ background: p.violetBorder }} />
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div
          className="border p-4 transition-colors"
          style={{ background: p.indigoBg, borderColor: p.indigoBorder }}
        >
          <p className="text-xs font-bold uppercase tracking-wide mb-1" style={{ color: p.indigoText }}>Track</p>
          <p className="text-sm font-semibold mb-1" style={{ color: p.nodeText }}>Comparison Cell in context</p>
          <ul className="space-y-0.5">
            {['Comparison Cell + specific Cycle', 'Comparison Cell + specific Scope', 'Owns Sessions & Results', 'Has governance posture', 'Submits Proposals per Loop'].map((t) => (
              <li key={t} className="text-xs flex items-center gap-1.5" style={{ color: p.indigoText }}>
                <span className="w-1 h-1 rounded-full flex-shrink-0" style={{ background: p.indigoBorder }} />
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
